import { useState, useEffect, useRef } from "react";
import backgroundimg from "../Images/banner-bg.jpg";
import emailjs from "emailjs-com";
import '../Css/oldcare.css';
import { countriesList } from "../utility/constants";
import { useMediaQuery } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { medicals } from "./config";
import NukaCarousel from "../tools/NukaCarousel";
import { faqs } from "./config";
import { hip } from "./config";
import { faqsss } from "./config";
import docgirl from "../Images/home/hip.png";
import hipani from "../Images/home/hip-animation.mp4";
import belt1 from "../Images/home/belt1.png";
import belt2 from "../Images/home/belt2.png";
import belt3 from "../Images/home/belt3.png";
import Ripplepic from "../Images/home/Ripple.png";
import HospitalTreatmentsShowcase from "./HospitalTreatmentsShowcase";
import ServiceCall from "../ServiceCall";
import {
    TextField,
    Button,
    Container,
    makeStyles,
    FormControl,
    InputLabel,
    InputAdornment,
    Input,
    MenuItem,
    FormHelperText,
    Select,
    Grid,
} from "@material-ui/core";
import { Mail, Phone, MapPin, User, Send, CheckCircle, Star, Shield, Users, Award } from 'lucide-react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: theme.spacing(4),
        "& .MuiTextField-root": {
            margin: theme.spacing(1),
        },
        "& .MuiFormControl-root": {
            margin: theme.spacing(1),
        },
    },
    button: {
        margin: theme.spacing(2, 0),
        backgroundColor: "#199a8e",
        "&:hover": {
            // Remove hover effect
            backgroundColor: "#199a8e",
        },
    },
    salutationFormControl: {
        width: "27%", // Adjust the width of the salutation select
    },
    gender: {
        width: "30%",
    },
    nameContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
    },
    nameField: {
        background: "white",
    },
    select: {
        border: "none", // Remove border
        width: "50px", // Adjust the width as needed
    },
}));

const Oldcare = () => {
    const classes = useStyles();
    const [loader, setLoader] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [phoneCode, setPhoneCode] = useState("+91");
    const [message, setMessage] = useState("");
    const [name, setName] = useState("");
    const [pin, setPin] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [gender, setGender] = useState("");
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const isTablet = window.innerWidth > 768 && window.innerWidth <= 1024;
    const videoRef = useRef(null);
    const sectionRef = useRef(null);
     const [loading, setLoading] = useState(false);
    const content = [
        {
          title: "Delivery of Devices and Services",
          text: "The device & services will be delivered by the Third Party Vendor or independent contractors. You accept and acknowledge that the Third Party Vendor or such other transporter/courier/delivery personnel, engaged by the Third Party Vendor or RxOne, shall be independent contractors in charge of the delivery of the Device and Services from the concerned Third Party Vendor to the address notified by You, with no control over the Devices and Services and no additional obligation apart from standard delivery obligations and duty of care.",
        },
        {
          title: "Role of RxOne",
          text: "You further accept and acknowledge that RxOne does not engage in the distribution of the Devices and Services and may provide the services of a third-party transporter/courier delivery personnel for the purposes of delivery of Devices and Services from the concerned Third Party Pharmacy to the address notified by You.",
        },
      ];
     const [submitted, setSubmitted] = useState(false);
      const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
      const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
      });
      const formRef = useRef(null);
      useEffect(() => {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              // Play the video when the section enters the viewport
              if (videoRef.current) {
                const iframe = videoRef.current.contentWindow;
                iframe.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
              }
            } else {
              // Pause the video when the section leaves the viewport
              if (videoRef.current) {
                const iframe = videoRef.current.contentWindow;
                iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
              }
            }
          },
          { threshold: .1 } // Adjust threshold for triggering
        );
    
        if (sectionRef.current) {
          observer.observe(sectionRef.current);
        }
    
        return () => {
          if (sectionRef.current) {
            observer.unobserve(sectionRef.current);
          }
        };
      }, []);
  
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
        };
    
        window.addEventListener("resize", handleResize);
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);
    const images = [belt1, belt2, belt3];
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = (e) => {
            setScrollY(e.target.scrollTop); // Track the scroll position within the box
        };

        const scrollBox = document.getElementById("parallax-scroll-box");
        scrollBox.addEventListener("scroll", handleScroll);

        return () => {
            scrollBox.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const isValidPhoneNumber = (phoneNumber) => {
        const numericPhoneNumber = phoneNumber.replace(/\D/g, "");
        return numericPhoneNumber.length === 10 && /^\d+$/.test(numericPhoneNumber);
    };
    const [expandedQuestions, setExpandedQuestions] = useState([]);

     const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const mode = process.env.REACT_APP_MODE; // e.g., 'dev', 'prod'

  const payload = {
    email: formData.email,
    country_code: '+91', // 🔧 Replace with dynamic code if available
    phone: formData.phone,
    name: formData.name,
    address: formData.address,
    source_url: 'https://rxone.app/shop/book-ripple-hippro',
    request_type: 'book-ripple-hippro',
    coupon_code: '', // 🔧 Optional: add value if neededcoupon_code: formData.coupon , // 🔧 Optional: add value if needed
  };

  try {
    await ServiceCall.post(`/rxopd/rxone/patient/treatment/advice/contactus/form/${mode}`, payload);

    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', phone: '', address: '' });
      setSubmitted(false);
    }, 3000);
  } catch (error) {
    console.error('API submission error:', error);
    alert('Failed to submit the form. Please try again.');
  } finally {
    setLoading(false);
  }
};


    const toggleQuestion = (id) => {
        if (expandedQuestions.includes(id)) {
            setExpandedQuestions(expandedQuestions.filter((qid) => qid !== id));
        } else {
            setExpandedQuestions([...expandedQuestions, id]);
        }
    };

    const titlle = 
    "Hip Pro Fall Prevention Belt - Ensuring Safety and Mobility | RxOne";
const desc = 
    "Explore the Hip Pro Fall Prevention Belt, designed to enhance safety and mobility. Ideal for individuals at risk of falls, providing superior support and comfort. Available now at RxOne.";
const handleLearnMoreClick = () => {
  if (sectionRef.current) {
    sectionRef.current.scrollIntoView({ behavior: "smooth" });
  }
};
    return (
        <>
            <Helmet>{<title>{titlle}</title>}</Helmet>
            <Helmet>{<meta name="description" content={desc} />}</Helmet>

          <section
  className="phantom-section"
  style={{
    marginTop: isMobile ? 0 : '6rem'
  }}
>
  <div className="phantom-container">
    <div className="phantom-grid">
      
      {/* Left Section */}
    <div className="phantom-left" >
  <img src={Ripplepic} alt="PanTum Logo" style={{
    marginTop: isMobile ? '0rem' : '-40px'
  }} className="phantom-logo"  />
  <h1>
    Hip Pro+: The Elderly's Guardian  <span className="highlight">Smart Belt</span>
  </h1>
  <p>
   Experience unmatched safety and comfort with Hip Pro, a cutting-edge belt crafted to safeguard the elderly from hip injuries. It's more than just fall prevention, it's about prioritizing your well-being.
  </p>
  <div className="phantom-buttons">
   <button className="btn-primary2"onClick={handleLearnMoreClick} >
  Learn More
</button>
    {/* <button className="btn-outline">Find a Testing Center</button> */}
  </div>
  <ul className="phantom-features">
    <li><span className="checkmark">✔</span> Protection with Automatic Inflation/Deflation</li>
    <li><span className="checkmark">✔</span> Emergency Alert System for Added Safety</li>
    <li><span className="checkmark">✔</span> Enhanced Night time Safety Features</li>
  </ul>
{/* <div
  style={{
    marginTop: "18px",
    fontWeight: 600,
    color: "#019a9e",
    fontSize: "1.05rem",
    letterSpacing: "0.5px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap"
  }}
  className="phantom-available-row"
>
  <span style={{ display: "inline-block", marginRight: 8 }}>Available in</span>
  <span className="phantom-available-city">
    <MapPin size={16} style={{ color: "#019a9e", marginRight: 4 }} />
    Delhi NCR
  </span>
  <span className="phantom-available-city">
    <MapPin size={16} style={{ color: "#019a9e", marginRight: 4 }} />
    Madhya Pradesh
  </span>
  <span className="phantom-available-city">
    <MapPin size={16} style={{ color: "#019a9e", marginRight: 4 }} />
    Imphal
  </span>
</div> */}
</div>

      {/* Right Form */}
      <div className="lg:pl-12" ref={formRef}>
  <div className="bg-white rounded-2xl shadow-2xl p-6 lg:p-8 relative overflow-hidden">
    {/* Decorative Elements */}
    <div className="absolute top-0 right-0 w-32 h-32 opacity-10 transform rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>
    <div className="absolute bottom-0 left-0 w-24 h-24 opacity-5 transform -rotate-12">
      <div className="w-full h-full rounded-full" style={{ backgroundColor: 'rgb(1, 154, 158)' }}></div>
    </div>

    {submitted ? (
      <div className="text-center py-4">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(1, 154, 158, 0.1)' }}>
          <CheckCircle className="w-8 h-8" style={{ color: 'rgb(1, 154, 158)' }} />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-1">Thank You!</h3>
        <p className="text-sm text-gray-600">Your message has been sent successfully. We'll get back to you soon.</p>
      </div>
    ) : (
      <>
       <div className="text-center mb-4">
  <h2 className="text-4xl font-extrabold text-gray-900 mb-3 flex items-center justify-center gap-3">
  <span
    style={{
      letterSpacing: "1px",
      textTransform: "uppercase",
      background: "linear-gradient(90deg, #019a9e 0%, #00c6b7 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      display: "inline-block"
    }}
  >
    Book
  </span>
  <img
    src={Ripplepic}
    alt="PanTum Logo"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      height: "40px",
      marginBottom: "2px"
    }}
  />
</h2>
  <p className="text-sm text-gray-600">
    Fill out the form and we'll contact you within 24 hours
  </p>
</div>

        <div className="space-y-4">
          {/* Name Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <User className="w-4 h-4 mr-2 text-gray-500" />
              Full Name *
            </label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Email Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Mail className="w-4 h-4 mr-2 text-gray-500" />
              Email Address *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Phone Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <Phone className="w-4 h-4 mr-2 text-gray-500" />
              Phone Number *
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Address Field */}
          <div>
            <label className="flex items-center text-sm font-semibold text-gray-700 mb-1">
              <MapPin className="w-4 h-4 mr-2 text-gray-500" />
              Address *
            </label>
            <textarea
              name="address"
              placeholder="Enter your complete address"
              rows="2"
              value={formData.address}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all duration-200 bg-gray-50 hover:bg-white resize-none"
              style={{ '--tw-ring-color': 'rgb(1, 154, 158)' }}
            />
          </div>

          {/* Submit Button */}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className={`w-full flex items-center justify-center px-6 py-3 rounded-lg font-semibold text-white transition-all duration-200 transform hover:scale-105 hover:shadow-lg ${
              loading ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-xl'
            }`}
            style={{
              backgroundColor: loading ? '#gray' : 'rgb(1, 154, 158)',
              boxShadow: loading ? 'none' : '0 4px 15px rgba(1, 154, 158, 0.3)',
            }}
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Submitting...
              </>
            ) : (
              <>
                <Send className="w-5 h-5 mr-2" />
                Book Now
              </>
            )}
          </button>

          {/* Trust Indicators */}
          {/* <div className="pt-3 border-t border-gray-100">
            <div className="flex items-center justify-center space-x-4 text-xs text-gray-500">
              <div className="flex items-center">
                <Shield className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                SSL Secured
              </div>
              <div className="flex items-center">
                <CheckCircle className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                No Spam
              </div>
              <div className="flex items-center">
                <Star className="w-4 h-4 mr-1" style={{ color: 'rgb(1, 154, 158)' }} />
                Trusted
              </div>
            </div>
          </div> */}
        </div>
      </>
    )}
  </div>
</div>

        

    </div>
  </div>
</section>
            <section
      ref={sectionRef}
      className="video-section"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "#fff",
        padding: "20px",
        marginTop: isMobile ? "12rem" : "15rem",
      }}
    >
      <h1
        style={{
          fontWeight: "800",
          fontSize: isMobile ? "20px" : "36px",
          marginBottom: "1rem",
          color: "rgb(15, 136, 148)",
          textAlign: "center",
          fontFamily: "Poppins",
          marginTop:"50px"
        }}
      >
        How Hip Pro+ Keeps You Safe
      </h1>
      <iframe
        ref={videoRef}
        className="section-video"
        src="https://www.youtube.com/embed/sB_IvXRzPD8?enablejsapi=1&mute=1&controls=0&modestbranding=1&rel=0&showinfo=0"
        title="How Hip Pro+ Keeps You Safe"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          width: "100%",
          maxWidth: "1000px",
          height: "auto",
          aspectRatio: "16/9",
          marginBottom: "2rem",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      ></iframe>

      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          gap: "1rem",
          width: "100%",
          maxWidth: "900px",
          marginBottom: "230px",
        }}
      >
        <div
          style={{
            flex: "1",
            padding: "2rem",
            background: "#fff",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            marginTop: "-.1rem",
          }}
        >
          <h2 style={{ fontSize: "1rem", marginTop: "-10px" }}>
            Advanced Technology Integration
          </h2>
          <p style={{ fontSize: "0.85rem", color: "#555" }}>
            Hip Pro+ combines electronic hardware with a sophisticated AI
            algorithm, enabling real-time analysis of movements at a frequency
            of up to 100 times per second.
          </p>
        </div>
        <div
          style={{
            flex: "1",
            padding: "1rem",
            background: "#fff",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontSize: "1rem", marginBottom: "1rem" }}>
            Precise Motion Detection
          </h2>
          <p style={{ fontSize: "0.85rem", color: "#555" }}>
            Utilizing motion-sensing technology embedded within a lightweight
            and comfortable belt, Hip Pro+ accurately identifies the wearer's
            posture and activity characteristics, including assessing the
            likelihood of falls.
          </p>
        </div>
        <div
          style={{
            flex: "1",
            padding: "1rem",
            background: "#fff",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontSize: "1rem", marginBottom: "1rem" }}>
            Intelligent Fall Prevention
          </h2>
          <p style={{ fontSize: "0.85rem", color: "#555" }}>
            Upon detection of posture or activity change, the belt quickly
            inflates cushions around the hips to prevent falls, using machine
            learning for accurate posture detection.
          </p>
        </div>
      </div>
    </section>

        <section
    style={{
        position: "relative",
        width: "100%",
        height: "100vh", // Full viewport height
    overflow: "hidden",
  }}
>
  {/* Scrollable Box */}
  <div
    id="parallax-scroll-box"
    style={{
      position: "relative",
      width: "100%",
      height: "100%",
      overflowY: "scroll",
      scrollBehavior: "smooth",
    }}
  >
    {/* Content Inside the Scroll Box */}
    <div
      style={{
        position: "relative",
        height: window.innerWidth <= 768 
        ? `${images.length * 70}vh` // Mobile height calculation
        : `${images.length * 140}vh`, // Desktop height calculation // Add vertical space (130% of viewport height per image)
      }}
    >
      {images.map((image, index) => {
       const imageOffset = index * (isMobile ? 80 : 130); 
        const parallaxStyle = {
          position: "absolute",
          top: `${imageOffset}vh`, // Add vertical spacing between images
          left: 0,
          width: "100%", // Cover full width of the viewport
          height: window.innerWidth <= 768 
          ? "78vh" // Mobile: Adjust to smaller viewport height
          : "140vh",           backgroundImage: `url(${image})`,
          backgroundSize: "contain", // Adjust to fit the full image
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        };

        return <div key={index} style={parallaxStyle}></div>;
      })}
    </div>
  </div>
</section>

      
<section className="terms-container">
      <h1 className="terms-heading">Terms and Conditions</h1>
      <div className="terms-content">
        {content.map((item, index) => (
          <div key={index} className="terms-item">
            <p>
              <strong>{item.title}: </strong>
              {item.text}
            </p>
          </div>
        ))}
      </div>
    </section>
     <HospitalTreatmentsShowcase />
    <h5
      
      style={{
        fontWeight: "800",
fontSize: isMobile ? "20px" : "36px",

        marginBottom: "1rem",
        
        color: "rgb(15, 136, 148)",
        textAlign: "center",
        fontFamily:"poppins",
    }}
    >
      Frequently Asked Questions
    </h5>

    <ul style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
      {hip.map((faq) => (
        <li className="languages card" key={faq.id}>
          <div>
            <strong>{faq.question}</strong>
            <button
              onClick={() => toggleQuestion(faq.id)}
              style={{
                border: "none",
                background: "none",
                display: "flex",
                justifyContent: "end",
                width: "100%",
                marginTop: "-22px",
              }}
            >
              <span>{expandedQuestions.includes(faq.id) ? "▲" : "▼"}</span>
            </button>
          </div>
          {expandedQuestions.includes(faq.id) && <p>{faq.answer}</p>}
        </li>
      ))}
    </ul>
    </>
  );
};
export default Oldcare;
